<template>
  <aw-shortlist-page />
</template>

<script>
  import { defineNuxtComponent } from 'nuxt/app';
  import AwShortlistPage from '~~/common/components/Page/ProductList/AwShortlistPage.vue';


  export default defineNuxtComponent({
    name: 'ShortlistPageShop',
    components: {
      AwShortlistPage,
    },
    setup () {
      // eslint-disable-next-line no-undef
      definePageMeta({
        layout: 'dynamic-content',
      });
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
</style>